var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 background_white font_lora"},[_c('h3',{staticClass:"mb-4"},[_vm._v("Blog Viewers")]),_vm._v(" "),(_vm.isLoaded)?_c('line-chart',{attrs:{"chartdata":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }